import { useState } from "react";

import Box from "@mui/material/Box";
import { IconButton } from "@covertree/ui/buttons/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";

interface HeaderProps {
  eyebrow: string;
  title: string;
  isEditMode: boolean;
  isIssueMode: boolean;
  disabled?: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onClose: () => void;
}

export function EndorsementLayoutHeader({
  eyebrow,
  title,
  isEditMode,
  isIssueMode,
  disabled = false,
  onSave,
  onDiscard,
  onClose,
}: HeaderProps) {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  const handleSave = () => {
    setMenuAnchor(null);
    onSave();
  };

  const handleDiscard = () => {
    setMenuAnchor(null);
    onDiscard();
  };

  return (
    <Box
      px={3}
      pt={2.5}
      pb={1}
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start">
      <Box>
        <Typography fontSize={16} variant="caption" color="text.secondary">
          {eyebrow}
        </Typography>
        <Typography variant="h3" mt={0.25}>
          {title}
        </Typography>
      </Box>
      <Stack direction="row" alignItems="center" gap={1.5}>
        {(isEditMode || isIssueMode) && (
          <>
            <IconButton
              onClick={(e) => setMenuAnchor(e.currentTarget)}
              disabled={disabled}
              aria-label="More options">
              <MoreVertIcon />
            </IconButton>
            <Menu
              anchorEl={menuAnchor}
              open={Boolean(menuAnchor)}
              onClose={() => setMenuAnchor(null)}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
              {isEditMode && <MenuItem onClick={handleSave}>Save</MenuItem>}
              <MenuItem onClick={handleDiscard} sx={{ color: "error.main" }}>
                Discard
              </MenuItem>
            </Menu>
          </>
        )}
        <IconButton
          onClick={onClose}
          disabled={disabled}
          aria-label="Close modal">
          <CloseIcon />
        </IconButton>
      </Stack>
    </Box>
  );
}
